import React from "react";

export const ShortScore = ({name, value, color}) => {
    return (
        <div className='flex-center shortScore'>
            <p className='shortScore__name'>{name}</p>
            <h2 className={`shortScore__value info${color}`}>{value}</h2>
        </div>
    )
}